/* Conference tabs for cg-division-grid (All / AFC / NFC …) and league tabs on the team hub. */
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-cg-dg-tab]');
  if (t) {
    const root = t.closest('[data-cg-dg]'), v = t.dataset.cgDgTab;
    root.querySelectorAll('[data-cg-dg-tab]').forEach((b) => b.classList.toggle('is-on', b === t));
    root.querySelectorAll('[data-cg-dg-conf]').forEach((c) => c.classList.toggle('is-hidden', !!v && c.dataset.cgDgConf !== v));
    return;
  }
  const l = e.target.closest('[data-cg-hub-tab]');
  if (l) {
    const root = l.closest('[data-cg-hub]'), v = l.dataset.cgHubTab;
    root.querySelectorAll('[data-cg-hub-tab]').forEach((b) => { b.classList.toggle('is-on', b === l); b.setAttribute('aria-selected', b === l); });
    root.querySelectorAll('[data-cg-hub-panel]').forEach((p) => { p.hidden = p.dataset.cgHubPanel !== v; });
    try { history.replaceState(null, '', '#' + v); } catch (err) {}
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const h = location.hash.slice(1), b = h && document.querySelector(`[data-cg-hub-tab="${CSS.escape(h)}"]`);
  if (b) b.click();
});
